import axios from "axios";
const jsonConfig = require("../../Config.json");

const createInterviewUser = async (payload, jdId) => {
    let allResponse = {}
    try {
        allResponse = await axios.post(`${jsonConfig.apiUrl}screeningsession/${jdId}`, payload, {
            headers: {
                "x-functions-key": jsonConfig.key,
            },
        });
         
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default createInterviewUser;